<template>
  <div class="position-relative">
    <b-form-input
      :value="selectedText"
      @click="showPopup"
      @focus="showPopup"
      :disabled="disabled"
      :size="size"
      readonly
      :placeholder="placeholder"
    />
    <i
      style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%)"
      :class="isShow ? 'bx bx-caret-up' : 'bx bx-caret-down'"
    ></i>
    <div v-if="isShow" class="popup-container">
      <div class="m-2 position-relative">
        <input
          type="text"
          ref="searchInput"
          v-model="searchText"
          class="p-1 rounded"
          placeholder="Lọc tìm kiếm"
        />
        <i
          style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%)"
          class="bx bx-search-alt-2"
        ></i>
      </div>
      <div class="list-container">
        <div
          v-for="item in filteredList"
          :key="item.id"
          class="list-item"
          @click="selectItem(item)"
          :class="{ active: value === item.id }"
        >
          {{ item.text }}
        </div>
        <div v-if="filteredList?.length === 0" class="emtry">Không tìm thấy kết quả</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Autocomplete',

    props: {
      list: {
        type: Array,
        default: () => [],
      },
      value: {
        type: String,
        default: '',
      },
      size: {
        type: String,
        default: 'sm',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: 'Tìm kiếm nhân viên',
      },
      maxShow: {
        type: Number,
        default: 10,
      },
    },

    data() {
      return {
        isShow: false,
        searchText: '',
      }
    },

    computed: {
      selectedText() {
        const selected = this.list.find(item => item.id === this.value)
        return selected ? selected.text : ''
      },

      filteredList() {
        if (!this.searchText) {
          // Trả về 10 item đầu tiên khi không có text tìm kiếm
          return this.list.slice(0, this.maxShow)
        }

        // Filter và giới hạn 10 kết quả khi có text tìm kiếm
        return this.list
          .filter(item => item.text.toLowerCase().includes(this.searchText.toLowerCase()))
          .slice(0, this.maxShow)
      },
    },

    created() {
      document.addEventListener('click', this.handleClickOutside)
    },

    beforeDestroy() {
      document.removeEventListener('click', this.handleClickOutside)
    },

    methods: {
      showPopup() {
        if (!this.disabled) {
          this.isShow = true
          this.$nextTick(() => {
            this.$refs.searchInput.focus()
          })
        }
      },

      selectItem(item) {
        this.$emit('input', item.id)
        this.isShow = false
        this.searchText = ''
      },

      handleClickOutside(event) {
        if (!this.$el.contains(event.target)) {
          this.isShow = false
          this.searchText = ''
        }
      },
    },
  }
</script>

<style scoped>
  .popup-container {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-top: 5px;
    z-index: 1000;
    box-shadow:
      rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
      rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  }

  .list-container {
    max-height: 200px;
    overflow-y: auto;
  }

  .list-item {
    padding: 8px 12px;
    cursor: pointer;
  }

  .emtry {
    padding: 8px 12px;
  }

  .list-item:hover {
    background-color: #2292ff;
    color: white;
  }

  .list-item.active {
    background-color: #ddd;
  }
</style>
